import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import {
  changeFieldValue,
  getCheckoutCarData,
} from 'app/services/businessFunctionHelpers';

const registrationNumber = {
  checkoutCarRegistrationNumberChange(initialRun?: boolean) {
    const { checkoutRegistrationNumber } = getCheckoutCarData();

    changeFieldValue(
      FieldsEnum.CheckoutCarRegistrationNumber,
      checkoutRegistrationNumber,
      FormsEnum.CheckoutForm
    );
  },
};

export default registrationNumber;
